import React from 'react'
import { useDepartments } from 'src/pages/AccountSettings/AccountSettings.hooks'
import { NONE_ID, NONE_NAME } from 'src/Utils/globalConstants'
import { FilterName, FilterParam } from '../../FilterBar.types'
import { FilterDropdown } from '../FilterDropdown'

export const DashboardDepartmentFilterDropdown = ({
  isNested = false,
}: {
  isNested?: boolean
}): JSX.Element => {
  const { data: departments } = useDepartments()
  const noDepartmentValue = {
    value: NONE_ID,
    label: NONE_NAME,
  }
  const filterValues = [
    noDepartmentValue,
    ...(departments?.getItemsList().map((department) => ({
      value: department.getName(),
      label: department.getName(),
    })) || []),
  ]

  return (
    <FilterDropdown
      filterParam={FilterParam.DASHBOARD_DEPARTMENT}
      filterName={FilterName.DASHBOARD_DEPARTMENT}
      filterValues={filterValues}
      isNested={isNested}
    />
  )
}
